import clsx from 'clsx'
import React, {useContext} from 'react'
import {makeStyles} from 'external/material'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import {TeacherContext} from 'teacher/context'
import QuestionBankFilters from './components/filters'
import Questions from './components/questions'

const useStyles = makeStyles(questionBankStyles)

export default function QuestionBank() {

  const classes = useStyles()
  const context = useContext(TeacherContext)
  const {quizSearch, quizQuestionBank, translate, updateState} = context
  const searchingDone = !quizSearch['question-bank']
  const questionsFound = quizQuestionBank.length > 0

  React.useEffect(()=>{
    updateState({
      quizQuestionBankCart: {$set: []},
      quizQuestionBankCartEl: {$set: null},
    })
  }, [])

  return (
    <Box className={classes.root} >
      <Box className={classes.filters}>
        <QuestionBankFilters />
      </Box>
      <Box className={classes.container}>
        <Fade in={searchingDone}>
          <Box className={clsx(classes.content, {questionsFound})}>
            {!questionsFound && (<Box className={classes.noQuestionsFound}>{translate('no-questions-found')}</Box>)}
            {questionsFound && (<Questions />)}
          </Box>
        </Fade>
      </Box>
    </Box>
  )
}

function questionBankStyles() {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      width: '100%',
    },
    noQuestionsFound: {
      flexGrow: 1,
      backgroundColor: '#f9f9f9',
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      justifyContent: 'center',
      fontSize: '28pt',
      color: '#8990a0',
      border: 'solid 1px #becfd7',
    },
    container: {
      display: 'flex',
      flexGrow: 1,
      overflow: 'hidden'
    },
    content: {
      padding: '10px 0',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
      flexGrow: 1,
      '&.questionsFound': {
        padding: '10px 10px 10px 0',
        '&::-webkit-scrollbar': {
          width: 6
        },
        '&::-webkit-scrollbar-track': {
          background: '#fff',
          padding: 2,
          border: 'solid 1px #d3d3d3',
          borderTop: 0,
          borderBottom: 0
        }
      }
    },
    filters: {
      display: 'flex',
      backgroundColor: '#fff',
      border: 'solid 1px #becfd7',
    }
  }
}
